module.exports = "<div dx-drop-down-box=\"dropDownOptions\"></div>\r\n"